import Block from './block';
import getChildren from '../../utils/defaultChildren';

export default {
	component: Block,
	getChildren: () => []
};
